import { RouteObject } from 'react-router-dom';

import PrivateRoute from '../hoc/PrivateRoute';
import Creditors from '../pages/Dashboard/creditors';
import Dashboard from '../pages/Dashboard';
import Debitors from '../pages/Dashboard/debitors';

export const dashboardRoutes: RouteObject[] = [
  {
    path: '/dashboard',
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
    children: [
      {
        path: '/dashboard/debitors',
        element: <Debitors />,
      },
      {
        path: '/dashboard/creditors',
        element: <Creditors />,
      },
    ],
  },
];
